module.exports = __webpack_public_path__ + "media/fonts/SFProText-Regular-cc7ed75809867295f6137a8725df5f69.ttf";